<template>
  <div class="zxfwxq">
    <div class="header">
      <div class="h1">黄骅市综合服务平台</div>
      <div class="h2">全面・便捷・专业 助力企业成长</div>
    </div>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item  :to="{ path: '/zxfw' }">咨询服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/zxfwxq' }">查看详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="bottom">
        <div class="flex">
          <div class="flex-1">
            <div class="title">{{datas.name}}</div>
            <div>
              <p>{{datas.subTitle}}</p>
            </div>
          </div>
          <div class="img"><el-image :src="datas.image"></el-image></div>
        </div>
         <div class="t1"><span>机构介绍</span></div>
          <div v-html="datas.notes"></div>
        <div style="text-align: center;margin-top: 50px">
          <el-button type="danger" class="btn" @click.stop="gotolink()">在线咨询</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="发送" width="500px" append-to-body :visible.sync="dialogTableVisible">
      <el-form ref="form" :model="shen" label-width="100px" :rules="rules" :inline="true">
        <el-form-item label="咨询详情" prop="detail">
          <el-input rows="5" class="inputWidth mb8" type="textarea" v-model="shen.detail"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input   v-model="shen.contacts" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="手机号"   prop="phone">
          <el-input  v-model.number="shen.phone" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="margin: 20px 0 0 160px" @click="submitForm()">保存</el-button>
          <el-button @click="dialogTableVisible=!dialogTableVisible">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {intermediarydetail} from "../../request/moudle/zxfw";

export default {
  name: "gonggaoxq",
  data(){
    return {
      shen:{},
      rules: {
        detail: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { type: 'number', message: '手机号必须为数字值'}
        ]
      },
      dialogTableVisible:false,
      datas:''
    }
  },
  created() {
    this.loadxq()
  },
  methods:{
    submitForm(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.shen.intermediaryId = this.$route.query.id
          this.$api.zxfw.consultMessage(this.shen).then((res)=>{
            this.dialogTableVisible=false
            this.$message({
              type: "success",
              message: "提交成功!"
            });
          })
        }
      })
    },
    loadxq(){
      this.$api.zxfw.intermediarydetail({
        id:this.$route.query.id
      }).then((res)=>{
        this.datas=res.data
      })
    },
    go(){
      this.$router.push({
        path:'/zxfwlist'
      })
    },
    gotolink(){
      this.shen={}
      this.dialogTableVisible=true
    }
  }
}
</script>

<style lang="scss" scoped>
  .zxfwxq{
     background: #fff;
    .header{
      height: 180px;
      background: url("../../assets/gxjy/gxjy.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 90px;
      text-align: center;
      color: #fff;
      .h1{
        font-size: 42px;
        font-weight: 500;
      }
      .h2{
        font-size: 22px;
        line-height: 80px;
      }
    }
    .content{
      width: 1200px;
      margin: 20px auto;
      .bottom{
        padding: 30px;
      }
      .title{
        font-size: 18px;
        font-weight: 550;
        line-height: 50px;
      }
      .img{
        width: 350px;
        height: 200px;
        background: #F1F3F3;
        margin-left: 30px;
      }
      .t1{
        color: #fff;
        border-bottom: 1px solid #eeeeee;
        margin: 25px 0;
        padding-bottom: 11px;
        span{
          padding: 8px 15px;
          background: #0078F2 ;
          border-bottom: 2px solid  #0078F2;
        }
      }
    }
  }
</style>